export const FormId = {
	AccountInfo: 'accountInfo',
	PersonalInfo: 'personalInfo',
	Links: 'links',
};
